import * as React from 'react';

// API
import apibridge from '../../apibridge';

// UTILS
import { validationErrorsToString } from '../../utils';

// PACKAGES
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import { SwitchTransition, CSSTransition } from 'react-transition-group';

// COMPONENTS
import Button from '../../components/Button';
import FileUpload from '../../components/FileUpload';
import LoadingSpinner from '../../components/LoadingSpinner';

// TYPES
import { OrganisationEditProfileImageCommand } from '../../api/models';
import { FileType } from '../../components/FileUpload';
import { closeModalType } from '../../components/GlobalModal';

interface EditLogoModalTypes {
	getSettingsData: () => Promise<void>;
	closeModal?: closeModalType;
}

interface LogoUploadData {
	createAttachments?: string[];
	attachments: FileType[];
}

const EditLogoModal: React.FC<EditLogoModalTypes> = ({ closeModal, getSettingsData }) => {
	// Error and Loading state
	const [formErrorMessage, setFormErrorMessage] = React.useState<string>('');

	const [isLoading, setIsLoading] = React.useState<boolean>(false);

	const initialData: LogoUploadData = {
		createAttachments: [],
		attachments: []
	};

	// Set up data state and initial data
	const [uploadLogoData, setUploadLogoData] = React.useState<LogoUploadData>(initialData);

	const validationSchema = Yup.object({});

	const initialValues = {
		createAttachments: uploadLogoData.createAttachments,
		attachments: uploadLogoData.attachments
	};

	const confirmUploadLogo = async (values: any) => {
		setIsLoading(true);

		if (values.attachments.length !== 0) {
			const data: OrganisationEditProfileImageCommand = {
				imageFile: values.attachments[0].id
			};

			const response = await apibridge.submitOrganisationLogo(data);

			if (response.isError) {
				setIsLoading(false);

				setFormErrorMessage(
					response.validationErrors.length
						? validationErrorsToString(response.validationErrors)
						: response.message || 'An error has occurred'
				);
			} else {
				setIsLoading(false);

				await getSettingsData();

				if (closeModal) {
					closeModal();
				}
			}
		} else {
			setIsLoading(false);
			if (closeModal) {
				closeModal();
			}
		}
	};

	return (
		<>
			{!!formErrorMessage ? (
				<div className="form-validation-error">{formErrorMessage}</div>
			) : (
				<SwitchTransition mode="out-in">
					<CSSTransition key={`key_${isLoading}`} timeout={600} classNames="standalone-fade" mountOnEnter unmountOnExit>
						{isLoading ? (
							<LoadingSpinner show={isLoading} />
						) : (
							<Formik
								initialValues={initialValues}
								validationSchema={validationSchema}
								onSubmit={confirmUploadLogo}
								enableReinitialize
							>
								{(formik) => {
									return (
										<Form translate="yes" className="general-form mtop-0">
											<div className="form-group">
												<label htmlFor="createAttachmentsInput" className="label">
													Add new logo
												</label>

												<div className="form-field mbtom-14">
													<FileUpload
														name="createAttachments"
														imagesOnly={true}
														maxSizeMb={5}
														multiple={false}
														onChange={(vals: string[], files: any[]) => {
															formik.setFieldValue('createAttachments', vals);
															formik.setFieldValue('attachments', files);
														}}
														files={formik.values.attachments}
													/>
												</div>
											</div>

											<div className="form-button-group">
												<Button type="submit" className="btn-primary w-100">
													Save
												</Button>
											</div>
										</Form>
									);
								}}
							</Formik>
						)}
					</CSSTransition>
				</SwitchTransition>
			)}
		</>
	);
};

export default EditLogoModal;
